import React from 'react';

export default function AdminPanel() {
  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold text-gray-800">Admin Panel</h1>
      <p className="text-sm text-gray-600 mt-2">Only superusers should see this page.</p>
    </div>
  );
}


